// extracted by mini-css-extract-plugin
export default {"add":"index_add__ndo9W","addb":"index_addb__qSrOh","addbb":"index_addbb__J8VbQ","assign":"index_assign__M5jLH"};